import { FC } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

import ImageToolSummaryBox from "./ImageToolSummaryBox";
import { hexToRgba } from "@/utils/theme";

const Box = styled(motion.div)`
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  box-shadow:
    0px 10px 30px rgba(34, 34, 34, 0.12),
    0px 20px 100px rgba(34, 34, 34, 0.06);
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  padding: 12px 24px;
  position: sticky;
  bottom: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SummaryBoxes = styled.div`
  display: flex;
`;

const Buttons = styled.div`
  display: flex;
  gap: 16px;
`;

const DownloadButton = styled.a`
  font-family: ${({ theme }) => theme.typography.button.fontFamily};
  padding: 0 16px;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  border-radius: 4px;
  height: 46px;
  justify-content: center;
  align-items: center;
  transition: 0.2s ease-out all;
  display: inline-flex;
  color: ${({ theme }) => theme.colors.purple};
  background-color: ${({ theme }) => hexToRgba(theme.colors.purpleLight, 0.15)};
  &:hover,
  &:active {
    background-color: ${({ theme }) =>
      hexToRgba(theme.colors.purpleLight, 0.25)};
  }
  &:disabled {
    color: ${({ theme }) => theme.colors.gray};
    background: ${({ theme }) => theme.colors.grayscaleLight};
  }
`;

interface Props {
  selectedStockImages: number[];
  selectedAiImages: number[];
  selectedInstagramImages: number[];
  setSelectedStockImages: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectedAiImages: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectedInstagramImages: React.Dispatch<React.SetStateAction<number[]>>;
}

const ImageToolFloatingBox: FC<Props> = ({
  selectedStockImages,
  selectedAiImages,
  selectedInstagramImages,
  setSelectedStockImages,
  setSelectedAiImages,
  setSelectedInstagramImages,
}) => {
  const selectedImages = selectedStockImages.concat(selectedAiImages);

  return (
    <Box
      initial={{ scale: 0, opacity: 0.3 }}
      animate={{ scale: 1, opacity: 1 }}
      exit={{ scale: 0, opacity: 0.3 }}
    >
      <SummaryBoxes>
        <ImageToolSummaryBox
          type="library"
          selectedImages={selectedStockImages}
          setSelectedImages={setSelectedStockImages}
          title="Stock Libraries"
        />
        <ImageToolSummaryBox
          type="instagram"
          selectedImages={selectedInstagramImages}
          setSelectedImages={setSelectedInstagramImages}
          title="Instagram"
        />
        <ImageToolSummaryBox
          type="midjourney"
          selectedImages={selectedAiImages}
          setSelectedImages={setSelectedAiImages}
          title="Midjourney"
        />
      </SummaryBoxes>
      <Buttons>
        <DownloadButton
          download
          href={`${
            process.env.REACT_APP_API_ENDPOINT
          }/image-library-zip/?media=${selectedImages.map(
            (selectedImage) => selectedImage
          )}`}
        >
          Download all
        </DownloadButton>
      </Buttons>
    </Box>
  );
};

export default ImageToolFloatingBox;
